import React from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/footer';

const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      {/* Main content - Add padding top to account for fixed navbar */}
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;